"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderItemPalletLabelsApiErrorCode = void 0;
exports.GetOrderItemPalletLabelsApiErrorCode = {
    CANNOT_GENERATE_PALLET_LABELS: 'CANNOT_GENERATE_PALLET_LABELS',
    ERROR_DURING_UPLOAD: 'ERROR_DURING_UPLOAD',
    ERROR_GETTING_SIGNED_URL: 'ERROR_GETTING_SIGNED_URL',
    INVALID_ORDER_STATE: 'INVALID_ORDER_STATE'
};
//# sourceMappingURL=get-order-item-pallet-labels-api-error-code.js.map